<script setup lang="ts">
const { promotionsUrlIframe } = useLinks();
</script>

<template>
  <div class="promotions-iframe">
    <iframe
      frameborder="0"
      :src="promotionsUrlIframe"
      title="Promotions Iframe"
    ></iframe>
  </div>
</template>

<style scoped lang="scss">
.promotions-iframe {
  width: 100%;
  height: 800px;
  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    position: relative;
    z-index: 5;
    overflow: hidden;
  }
}
</style>
